const availabilityMenu = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const menus = document.querySelectorAll('[data-availability]');
    if (!menus.length) return;

    const html = document.documentElement;

    const STATES = ['default', 'medium', 'large'];
    let fontState = localStorage.getItem('a11y-font-size') || 'default';

    // ---------- Shared helpers ----------
    const applyFontState = () => {
      html.classList.remove('font-size-medium', 'font-size-large');

      if (fontState === 'medium') html.classList.add('font-size-medium');
      if (fontState === 'large') html.classList.add('font-size-large');

      localStorage.setItem('a11y-font-size', fontState);

      // update buttons in ALL menus
      menus.forEach(menu => {
        const btnMinus = menu.querySelector('.font-size-minus');
        const btnPlus  = menu.querySelector('.font-size-plus');

        if (!btnMinus || !btnPlus) return;

        btnMinus.disabled = fontState === 'default';
        btnMinus.setAttribute('aria-disabled', btnMinus.disabled);

        btnPlus.disabled = fontState === 'large';
        btnPlus.setAttribute('aria-disabled', btnPlus.disabled);
      });
    };

    const applyContrastState = (enabled) => {
      html.classList.toggle('contrast-mode', enabled);
      localStorage.setItem('a11y-contrast', enabled);

      // sync all checkboxes
      menus.forEach(menu => {
        const checkbox = menu.querySelector('#contrast_mode');
        if (checkbox) checkbox.checked = enabled;
      });
    };

    // ---------- Init shared state ----------
    applyFontState();
    applyContrastState(localStorage.getItem('a11y-contrast') === 'true');

    // ---------- Bind each menu ----------
    menus.forEach(menu => {
      const toggle = menu.querySelector('.availability-toggle');
      const panel  = menu.querySelector('.availability-menu-holder');

      const btnMinus = menu.querySelector('.font-size-minus');
      const btnPlus  = menu.querySelector('.font-size-plus');
      const contrastCheckbox = menu.querySelector('#contrast_mode');
      const resetBtn = menu.querySelector('.reset-defaults');

      if (!toggle || !panel) return;

      // Toggle open/close
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      });

      // Click outside close (per menu)
      document.addEventListener('click', (e) => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (!isOpen) return;
        if (menu.contains(e.target)) return;

        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      });

      // Font controls
      btnPlus?.addEventListener('click', () => {
        const index = STATES.indexOf(fontState);
        if (index < STATES.length - 1) {
          fontState = STATES[index + 1];
          applyFontState();
        }
      });

      btnMinus?.addEventListener('click', () => {
        const index = STATES.indexOf(fontState);
        if (index > 0) {
          fontState = STATES[index - 1];
          applyFontState();
        }
      });

      // Contrast toggle
      contrastCheckbox?.addEventListener('change', (e) => {
        applyContrastState(e.target.checked);
      });

      // Reset
      resetBtn?.addEventListener('click', () => {
        fontState = 'default';
        applyFontState();
        applyContrastState(false);

        localStorage.removeItem('a11y-font-size');
        localStorage.removeItem('a11y-contrast');
      });
    });
  });
};

export default availabilityMenu;
